import ViewReports from './ViewReports'

export default ViewReports
